import styled from 'styled-components';
import { Checkbox } from '../checkbox';
import { themeColor } from '../../../theme/getters';

export const Container = styled.ul`
  user-select: none;
  padding: 0;
  margin: 0;
  list-style-type: none;
`;

export const WhiteCheckbox = styled(Checkbox)`
  flex: 0 0 auto;
  padding-right: 16px;
  align-self: stretch;
  align-items: center;
  cursor: pointer;
  overflow: hidden;

  div {
    margin: 0;
    background: ${themeColor('pinkWash')};
    border-color: ${themeColor('middleGray')};
    transform: none;
  }

  div > div {
    background: ${({ value }) => value && themeColor('black')};
  }
`;
